export default __webpack_public_path__ + "static/media/LOGOUT.bc40eb43.svg";